import { onScopeDispose, ref, watch, type Ref } from 'vue';

export const SNACKBAR_DEFAULT_MS = 3000;

type SnackbarDetail = { show?: boolean; type?: string; duration?: number } | null | undefined;

export const isSuccessSnackbar = (type?: string) => type === 'message' || type === 'success';

// A notice shows unless it says `show: false`; many callers set only a title
// and type. The first route's middleware runs before the app mounts, so a
// notice raised there is already showing when this starts watching;
// `immediate` keeps it.
// Each new detail object restarts the timer, so back-to-back notices each get
// their full time on screen.
export const useSnackbarVisibility = (detail: Ref<SnackbarDetail>, close: () => void) => {
   const visible = ref(false);
   let timer: ReturnType<typeof setTimeout> | undefined;
   watch(
      () => (detail.value && detail.value.show !== false ? detail.value : null),
      current => {
         clearTimeout(timer);
         visible.value = !!current;
         if (!current) return;
         timer = setTimeout(close, current.duration ?? SNACKBAR_DEFAULT_MS);
      },
      { immediate: true },
   );
   onScopeDispose(() => clearTimeout(timer));
   return visible;
};
